import { Stack, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function EmptyTable() {
	return (
		<Stack
			spacing="12px"
			alignItems="center"
			sx={{
				pt: '50px',
			}}
		>
			<SearchIcon
				sx={{
					color: '#146992',
					height: '40px',
					width: '40px',
				}}
			/>
			<Typography
				sx={{
					color: '#000000DE',
					fontSize: '18px',
					fontWeight: '600',
					fontFamily: 'Roboto',
					textAlign: 'center',
				}}
			>
				No se encontró historial para este SKU
			</Typography>
		</Stack>
	);
}
